import { render, staticRenderFns } from "./updateRecord.vue?vue&type=template&id=feb2ed98&scoped=true&"
import script from "./updateRecord.vue?vue&type=script&lang=js&"
export * from "./updateRecord.vue?vue&type=script&lang=js&"
import style0 from "./updateRecord.vue?vue&type=style&index=0&id=feb2ed98&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb2ed98",
  null
  
)

export default component.exports